import { basicEnum } from "./base";

export const DisbursementStatusEnum = basicEnum([
    {
        label: "Menunggu",
        value: "P", // Pending
    },
    {
        label: "Berhasil",
        value: "S", // Success
    },
    {
        label: "Gagal",
        value: "F", // Failed
    },
]);

export namespace DisbursementStatusEnum {
    export type Labels = (typeof DisbursementStatusEnum)["labels"][number];
    export type Values = (typeof DisbursementStatusEnum)["values"][number];
}
